import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogApplyCancelButtonsComponent, HKButtonDirective } from '@herrenknecht-connected/angular-shared-ui-base-components';
import { NgIf } from '@angular/common';

@Component({
  selector: 'hk-base-modal',
  template: `
    <div mat-dialog-title class="!mx-6 !my-2 !flex items-center justify-between border-b border-hk_gray-100 !p-0">
      <div class="flex-1 !font-medium" *ngIf="title">{{ title }}</div>
      <ng-content select="[titleContent]"></ng-content>
      <button *ngIf="!hideCloseButton" hk-button-close mat-dialog-close (click)="onCancel()" data-testid="hk-modal-close-button">
        <i class="ph ph-x close-button-icon"></i>
      </button>
    </div>
    <mat-dialog-content class="!my-2 !flex">
      <ng-content></ng-content>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!border-t !border-hk_gray-100 !px-6" *ngIf="!hideCancelButton || !hideApplyButton">
      <span class="mr-auto">
        <ng-content select="[info]"></ng-content>
      </span>
      <ng-content select="[additionalButtons]"></ng-content>
      <hk-dialog-apply-cancel-buttons
        [hideCancelButton]="hideCancelButton"
        [hideApplyButton]="hideApplyButton"
        [isApplyPossible]="isApplyPossible"
        (cancel)="onCancel()"
        (apply)="onApply()"
      ></hk-dialog-apply-cancel-buttons>
    </mat-dialog-actions>
  `,
  host: { class: 'flex flex-1 flex-col overflow-y-auto' },
  imports: [DialogApplyCancelButtonsComponent, MatDialogActions, MatDialogContent, MatDialogTitle, HKButtonDirective, MatDialogClose, NgIf],
  standalone: true,
})
export class BaseModalComponent {
  @Input() isApplyPossible = true;
  @Input() hideCloseButton = false;
  @Input() hideCancelButton = false;
  @Input() hideApplyButton = false;
  @Input() dialogReturnData?: object;
  @Input() title?: string;
  @Input() closeOnApply = true;
  @Output() cancel = new EventEmitter();
  @Output() apply = new EventEmitter();

  constructor(
    private dialogReference: MatDialogRef<BaseModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: unknown,
  ) {}

  onCancel(): void {
    this.cancel.emit();
    this.dialogReference.close();
  }

  onApply(): void {
    this.apply.emit();
    if (this.closeOnApply) this.dialogReference.close(this.dialogReturnData);
  }
}
